import { Component } from '@angular/core';

@Component({
  selector: 'app-other-activities',
  imports: [],
  templateUrl: './other-activities.component.html',
  styleUrl: './other-activities.component.css'
})
export class OtherActivitiesComponent {

}
